import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const PositionsIconSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_127_133)">
            <path
                d="M34.5 20.5C34.5 14.711 29.789 10 24 10C18.211 10 13.5 14.711 13.5 20.5H10.0455L12.1875 35.4963C12.3917 36.9243 13.633 38 15.075 38H32.8947C34.3367 38 35.578 36.9232 35.7822 35.4963L37.9242 20.5H34.5ZM24 11.1667C29.1462 11.1667 33.3334 15.3538 33.3334 20.5H14.6667C14.6667 15.3538 18.8539 11.1667 24 11.1667ZM34.6272 35.3307C34.5047 36.187 33.7592 36.8333 32.8947 36.8333H15.075C14.2094 36.8333 13.465 36.187 13.3425 35.3307L11.3907 21.6667H36.579L34.6272 35.3307ZM19.3334 28.0833H28.6667V29.25H19.3334V28.0833Z"
                fill="currentColor" />
        </g>
        <defs>
            <clipPath id="clip0_127_133">
                <rect width="28" height="28" fill="currentColor" transform="translate(10 10)" />
            </clipPath>
        </defs>
    </svg>
)
const Positions: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} style={{ fontSize: '40px' }}>
        {PositionsIconSvg}
    </SvgIcon>
)
export default Positions
